/**
 * Client-side length check for the login form submit button.
 * Bounds: `authLoginDefaults.json` + `authPasswordDefaults.json`.
 *
 * Login charset is not required here: the API lowercases login, and booking
 * pre-created logins like `an_5769` are 7 characters (minLength 6).
 */

import {
  AUTH_LOGIN_MIN_LENGTH,
  AUTH_LOGIN_MAX_LENGTH
} from './authLoginDefaults.js';
import {
  AUTH_PASSWORD_MIN_LENGTH,
  AUTH_PASSWORD_MAX_LENGTH
} from './authPasswordDefaults.js';

export function isLoginFormValid(login, password) {
  const loginLen = String(login ?? '').trim().length;
  const passwordLen = String(password ?? '').length;
  return (
    loginLen >= AUTH_LOGIN_MIN_LENGTH &&
    loginLen <= AUTH_LOGIN_MAX_LENGTH &&
    passwordLen >= AUTH_PASSWORD_MIN_LENGTH &&
    passwordLen <= AUTH_PASSWORD_MAX_LENGTH
  );
}
